import React from 'react';
import ReactDOM from 'react-dom';
import { TireFinderShell } from '../TireFinderShell';
import { createStorage } from '../../utilities/storage';
import { TireFinder } from '.';
import { NoResultsFound } from './NoResultsFound';

const initializeTireFinder = (isFinderPage = false) => {
  const tireFinderContainer = document.getElementById('tireFinder');
  const params = new URLSearchParams(window.location.search);
  const hasNoResults = params.get('error') === 'no-results-found';
  const quantityData = createStorage('tireFinderQuantityData');
  // reset quantity value
  quantityData.remove();

  if (!tireFinderContainer) return;
  ReactDOM.render(
    <TireFinderShell>
      <TireFinder isFinderPage={isFinderPage} />
      {hasNoResults && <NoResultsFound />}
    </TireFinderShell>,
    tireFinderContainer,
  );
};

export { initializeTireFinder };
